/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { networkGetNetworkDns } from "../../funcs/networkGetNetworkDns.js";
import { GetNetworkDnsRequest$zodSchema } from "../../models/getnetworkdnsop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetNetworkDnsRequest$zodSchema,
};

export const tool$networkGetNetworkDns: ToolDefinition<typeof args> = {
  name: "network-get-network-dns",
  description: `执行DNS解析查询

想知道一个域名指向了哪个IP？或者它的邮件服务器是谁？这个接口就像一个在线的 \`dig\` 或 \`nslookup\` 工具。

## 功能概述
你可以查询指定域名的各种DNS记录，包括 \`A\` (IPv4), \`AAAA\` (IPv6), \`CNAME\` (别名), \`MX\` (邮件交换), \`NS\` (域名服务器) 和 \`TXT\` (文本记录)。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await networkGetNetworkDns(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
